export default "<p>footer works!</p>\n"